import IconButton from '@mui/material/IconButton'
import SvgIcon from '@mui/material/SvgIcon'
import Tooltip from '@mui/material/Tooltip'
import capitalize from 'lodash/capitalize'
import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'

import api from 'api'
import { CACHE_TAG_CONFIGURED_SERVICES_LIST, CACHE_TAG_WORK_ORDER_LIST } from 'api/cacheTagTypes'
import { ReactComponent as ReactiveAccountIcon } from 'assets/customers/ReactiveAccount.svg'
import ReactivateAccountDialog from 'components/customer-details/content/common/reactivate-account-dialog/ReactivateAccountDialog'
import { getCustomerDetails } from 'middleware/actions/customers'
import T from 'T'

type ReactivateAccountIconButtonProps = {
  accountId: string
  customerDetails: {
    active?: boolean | null
    accountName?: string | null
    accountNumber?: string | null
  } | null
}

const ReactivateAccountIconButton = ({ accountId, customerDetails }: ReactivateAccountIconButtonProps) => {
  const dispatch = useDispatch()
  const [isOpenReactivateDialog, setIsOpenReactivateDialog] = useState(false)
  const isActiveAccount = customerDetails?.active

  const handleActivateDeactivateSuccess = useCallback(() => {
    dispatch(getCustomerDetails({ accountId }))
    // Trigger configured service & work order table updates
    dispatch(api.util.invalidateTags([CACHE_TAG_CONFIGURED_SERVICES_LIST, CACHE_TAG_WORK_ORDER_LIST]))
  }, [dispatch, accountId])

  const handleAccountActivateDeactivate = useCallback(() => {
    if (!isActiveAccount) setIsOpenReactivateDialog(true)
  }, [isActiveAccount])

  const handleCloseReactivateDialog = useCallback(() => setIsOpenReactivateDialog(false), [])

  return (
    <>
      <Tooltip arrow title={capitalize(`${T.REACTIVATE} ${T.ACCOUNT}`)}>
        <span>
          <IconButton onClick={handleAccountActivateDeactivate}>
            <SvgIcon inheritViewBox>
              <ReactiveAccountIcon />
            </SvgIcon>
          </IconButton>
        </span>
      </Tooltip>
      <ReactivateAccountDialog
        accountId={accountId}
        accountName={customerDetails?.accountName ?? ''}
        accountNumber={customerDetails?.accountNumber ?? undefined}
        isOpen={isOpenReactivateDialog}
        onClose={handleCloseReactivateDialog}
        onReactivated={handleActivateDeactivateSuccess}
      />
    </>
  )
}

export default ReactivateAccountIconButton
